import * as React from 'react';
import * as moment from 'moment';
import { resolve } from 'inversify-react';
import { Button, Col, Row } from 'antd';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as uuid from 'uuid';
import { connect } from "react-redux";

import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DataLocalService } from 'src/core/services/data-local.service';
import { IdentityService } from 'src/core/services/identity.service';
import { ContextService } from 'src/core/services/context.service';
import { TextView } from 'src/core/ui/text.view';
import { DateView } from 'src/core/ui/date.view';
import { MarketEditorController } from 'src/app/general/market/parts/market-editor.controller';
import { ProductTypeEditorController } from 'src/app/products/products/parts/product-type-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { PaxOccupancyView } from './parts/pax-occupancy.view';
import { QuoteDataService, QuoteItemModel } from 'src/app/bookings/quotes/form/quote-form.data';
import { SearchResultView } from 'src/app/bookings/search/results/search-results.view';
import { CalculatePriceService } from 'src/app/bookings/shared/calculate-prices.service';

interface Props extends ComponentViewProps<ContractItem> {
	formatService: any;
	defaultLanguage: string;
	mode: ControlMode;
	breadcrumb?: any[];
	defaultMarket: number;
	disabled?: boolean;
	product: ProductItem | TourItineraryItem;
}

interface PropsFromState {
	dates: ContractRangeDateItem[];
	category?: ProductCategorySummary;
}

interface State {
	modalOpen: boolean;
	searchType: 'Accommodation' | 'CarRent' | 'Transfer' | 'Flights' | 'General';
	search: Search & SearchDates & SearchSimulation | null;
	productType?: number,
	data: {
		fakeModel: QuoteItem | null;
		bookingDate: Date;
		startDate: Date;
		endDate: Date;
		productId: number,
		categoryId: number,
		productCategoryDisplayName: string,
		nights: number
	}
}

@observer
class ContractSimulatorView extends React.Component<Props & PropsFromState, State> {
	@resolve
	calculatePriceService: CalculatePriceService;

	@observable
	protected occupancies: Occupancy[] = [];

	@observable
	protected quoteDataService: QuoteDataService;

	@observable
	paxes: PersonOccupancy[] = [];

	@observable
	dataSet: DataLocalService<ProductSearchResult>;

	@observable
	messages: DataLocalService<Message>;

	@observable
	currentSearch: Search;

	@observable
	searchProducts = false;
	@resolve
	private identityService: IdentityService;

	@resolve
	contextService: ContextService;


	constructor(props: Props & PropsFromState) {
		super(props);

		let lastDateBand: any = null;

		if (this.props.model && this.props.dates && this.props.dates.length > 0) {
			lastDateBand = this.props.dates[this.props.dates.length - 1];
		}

		let product: ProductItem;
		if (props.product) {
			if (props.product.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
				product = props.product as ProductItem;
			} else {
				product = (props.product as TourItineraryItem).product;
			}
		}
		this.state = {
			modalOpen: false,
			data: {
				fakeModel: null,
				bookingDate: new Date(),
				startDate: lastDateBand ? lastDateBand.serviceDateFrom : new Date(),
				endDate: lastDateBand ? moment.utc(lastDateBand.serviceDateFrom).add(1, 'day').startOf('day').toDate() : moment.utc().add(1, 'day').startOf('day').toDate(),
				productId: product ? product.id : null,
				productCategoryDisplayName: this.props.category ? this.props.category.displayName : null,
				categoryId: this.props.category ? this.props.category.id : null,
				nights: 1
			},
			productType: product ? product.productType : null,
			search: null,
			searchType: this.getProductType(product ? product.productType : null)
		};


	}

	reloadDataServices() {
		this.quoteDataService = QuoteDataService.make(this.contextService);
		this.occupancies.splice(0, this.occupancies.length);
		this.paxes.splice(0, this.paxes.length);
		this.paxes.push({ name: 'Adult 1', age: 30, id: uuid.v4() });
		this.paxes.push({ name: 'Adult 2', age: 30, id: uuid.v4() });
		this.paxes.push({ name: 'Child 1', age: 10, id: uuid.v4() });
		this.paxes.push({ name: 'Child 2', age: 10, id: uuid.v4() });
		this.paxes.push({ name: 'Infant 1', age: 1, id: uuid.v4() });
		this.paxes.push({ name: 'Infant 2', age: 1, id: uuid.v4() });
		this.occupancies.push({ unit: 1, paxs: this.paxes.map(x => x) });
		this.dataSet = new DataLocalService([]);
		let user = this.props.model ? this.props.model.entity.createdBy : this.identityService.userId;
		let lastDateBand: any = null;

		if (this.props.model && this.props.dates && this.props.dates.length > 0) {
			lastDateBand = this.props.dates[this.props.dates.length - 1];
		}
		const fakeModel = new QuoteItemModel(this.quoteDataService.add(user, 0, this.props.defaultLanguage, 0, 0));

		let product: ProductItem;
		if (this.props.product) {
			if (this.props.product.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
				product = this.props.product as ProductItem;
			} else {
				product = (this.props.product as TourItineraryItem).product;
			}
		}
		this.setState({
			data: {
				fakeModel: fakeModel,
				bookingDate: new Date(),
				startDate: lastDateBand ? lastDateBand.serviceDateFrom : new Date(),
				endDate: lastDateBand ? moment.utc(lastDateBand.serviceDateFrom).add(1, 'day').startOf('day').toDate() : moment.utc().add(1, 'day').startOf('day').toDate(),
				productId: this.props.product ? this.props.product.id : null,
				productCategoryDisplayName: this.props.category ? this.props.category.displayName : null,
				categoryId: this.props.category ? this.props.category.id : null,
				nights: 1
			},
			productType: product ? product.productType : null,
			search: null,
			searchType: this.getProductType(product ? product.productType : null)
		});
	}

	@autobind
	handleModal() {
		this.setState({
			modalOpen: true
		})
	}

	@autobind
	closeModal() {
		this.setState({
			modalOpen: false
		});
	}

	@autobind
	async emptyHandler(params?: any, params2?: any) {
		return false;
	}

	@autobind
	cleanData() {
		this.reloadDataServices();
	}

	@autobind
	search() {
		this.props.setBusy(true);

		this.createSearch(this.occupancies)
			.then((res) => {
				this.dataSet = new DataLocalService(res.items);
				this.messages = new DataLocalService(res.messages);
				this.props.setBusy(false);
			})
			.catch((reason) => {
				this.props.setBusy(false);
			});
	}


	@autobind
	async createSearch(occupancy: any[]): Promise<ApiResult> {
		const type = this.getProductType(this.state.productType);

		const common: Search & SearchDates & SearchSimulation = {
			productId: this.state.data.productId,
			productExternalId: null,
			isActive: true,
			occupancies: occupancy,
			type: type,
			searchInCache: false,
			searchId: uuid.v4(),
			apiNames: [],
			startDate: this.state.data.startDate,
			endDate: this.state.data.endDate,
			contractId: this.props.model ? this.props.model.id : null,
			facets: []
		}

		await this.setState({
			search: common,
			searchType: type
		});

		return this.calculatePriceService.searchSimulation(
			common,
			this.state.data.fakeModel.marketId,
			this.state.data.bookingDate,
			this.props.defaultLanguage,
			null
		);
	}

	@autobind
	private async deletePaxs(paxsDelete: QuotePaxItem[]) {
		return true;
	}

	getProductType(type): 'Accommodation' | 'CarRent' | 'Transfer' | 'Flights' | 'General' {
		switch (type) {
			case 0:
				return 'General';
			case 1:
				return 'Accommodation';
			case 2:
				return 'CarRent';
			case 3:
				return 'Transfer';
			case 4:
				return 'Flights';
			case 5: // Room
				return 'Accommodation';
			default:
				return 'General';
		}
	}

	componentDidMount() {
		this.props.setBusy(true);
		this.reloadDataServices();
		this.props.setBusy(false);
	}

	render() {
		const { disabled } = this.props;
		const { data } = this.state;

		const modelIsNotValid = data.fakeModel == null || this.paxes == null
			|| this.paxes.length == 0 || !(data.fakeModel.marketId > 0)
			|| this.state.productType == null || data.productId == null;

		return (
			<div className="card card-borderless">
				<Row gutter={16}>
					<Col xs={24} lg={6}>
						<Button
							disabled={disabled}
							onClick={this.cleanData}
							style={{ 'marginRight': '5px' }}>
							Reset
						</Button>
						<Button
							disabled={modelIsNotValid || disabled}
							type='primary'
							onClick={this.search}>
							Calculate
						</Button>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						{this.props.model == null && <Row gutter={16}>
							<Col xs={24} lg={8}>
								<ProductTypeEditorController
									label='Product Type'
									required
									mode={this.props.model != null ? 'display' : 'edit'}
									onChanged={(value) => {

										this.setState({
											productType: value,
											data: { ...data, productId: undefined },
											searchType: this.getProductType(value)
										});
									}}
									value={this.state.productType}
									setBusy={this.props.setBusy}
									options={[
										{ value: 0, label: 'General' },
										{ value: 1, label: 'Accomodation' },
										{ value: 2, label: 'Car Rent' },
										{ value: 3, label: 'Transfer' },
										{ value: 4, label: 'Flight' },
										{ value: 5, label: 'Room' }
									]}
								/>
							</Col>
							<Col xs={24} lg={8}>
								<ProductEditorController
									label="Product"
									mode={this.props.model == null && this.state.productType != null ? 'edit' : 'display'}
									onChanged={(value) => {
										const productId = value != null ? value.id : null;
										const categoryId = value != null ? value.categoryId : null;
										const productCategoryDisplayName = value != null ? value.categoryDisplayName : null;
										this.setState({
											data: { ...data, productId, categoryId, productCategoryDisplayName }
										});
									}}
									value={data.productId}
									productType={this.state.productType}
									setBusy={this.props.setBusy}
								/>
							</Col>

							<Col xs={24} lg={8}>
								<MarketEditorController
									mode={disabled ? 'display' : 'edit'}
									onChanged={(value) => {
										const marketId = value != null ? value.id : null;
										this.setState({
											data: {
												...data,
												fakeModel: { ...data.fakeModel, marketId }
											}
										});
									}}
									value={data.fakeModel && data.fakeModel.marketId != 0 ? data.fakeModel.marketId : null}
									setBusy={this.props.setBusy}
									label="Market"
								/>
							</Col>
						</Row>
						}
						{this.props.model != null && <Row gutter={16}>
							<Col xs={24} lg={24}>
								<MarketEditorController
									mode={disabled ? 'display' : 'edit'}
									onChanged={(value) => {
										const marketId = value != null ? value.id : null;
										this.setState({
											data: {
												...data,
												fakeModel: { ...data.fakeModel, marketId }
											}
										});
									}}
									value={data.fakeModel && data.fakeModel.marketId != 0 ? data.fakeModel.marketId : null}
									setBusy={this.props.setBusy}
									label="Market"
								/>
							</Col>
						</Row>
						}
						<Row gutter={16}>
							<Col xs={24} lg={6}>
								<DateView
									label="Booking date"
									mode={disabled ? 'display' : 'edit'}
									value={data.bookingDate}
									onChanged={(newVal) => {
										let model = data;
										model.bookingDate = newVal;
										this.setState({ data: model });
									}}
									format="small-date"
									dateUsage="utc"
								/>
							</Col>
							<Col xs={24} lg={6}>
								<DateView
									label="Start date"
									mode={disabled ? 'display' : 'edit'}
									value={data.startDate}
									onChanged={(newVal) => {
										let model = data;
										model.startDate = newVal;
										model.endDate = moment.utc(model.startDate).add(model.nights, 'day').toDate();
										this.setState({ data: model });
									}}
									format="small-date"
									dateUsage="utc"
								/>
							</Col>
							<Col xs={24} lg={6}>
								<DateView
									label="End date"
									mode={disabled ? 'display' : 'edit'}
									value={data.endDate}
									onChanged={(newVal) => {
										let model = data;
										model.endDate = newVal;
										model.nights = moment.utc(model.endDate).diff(model.startDate, 'day');
										this.setState({ data: model });
									}}
									format="small-date"
									dateUsage="utc"
								/>
							</Col>
							<Col xs={24} lg={6}>
								<TextView
									label="Nights"
									mode="edit"
									value={data.nights}
									onChanged={(newVal) => {
										let model = data;
										model.nights = newVal;
										model.endDate = moment.utc(model.startDate).add(model.nights, 'day').toDate();
										this.setState({ data: model });
									}}
								/>
							</Col>
						</Row>
					</Col>
					<Col xs={24} lg={12}>
						{
							this.paxes.length > 0 && this.occupancies.length > 0 &&
							<PaxOccupancyView
								paxs={this.paxes}
								occupancies={this.occupancies}
								type={this.state.searchType}
								setBusy={this.props.setBusy}
							/>
						}
					</Col>
				</Row>
				<Row gutter={16} className="mt-3">
					<Col xs={24}>
						<div className="card card-borderless">
							<SearchResultView
								count={this.dataSet.count}
								showAllExpanded={true}
								fullSreen={true}
								typeSearch={this.state.searchType}
								showSearch={false}
								yourSearch=''
								mode={disabled ? 'display' : 'edit'}
								onProductSelected={(a, b) => { }}
								currentSearch={this.state.search}
								model={this.dataSet}
								setBusy={this.props.setBusy}
								messages={this.messages}
								bookingDate={data.bookingDate}
								languageCode={data.fakeModel ? data.fakeModel.languageCode : ""}
								marketId={data.fakeModel ? data.fakeModel.marketId : undefined}
							/>
						</div>
					</Col>
				</Row>
			</div>
		);
	}
}

const mapStateToProps = (
	state: IApplicationState,
	props: Props
): PropsFromState => {
	const contract = state.otherLoadedEntities.find(e => e.entity == props.model.entity) as ContractItem;
	const productStore = state.otherLoadedEntities.find(e => e.entity == props.product.entity) as Model;
	let product: ProductItem;
	if (productStore) {
		if (productStore.entity.getType() == Model.Products.Logic.ViewModels.ProductItem) {
			product = productStore as ProductItem;
		} else {
			product = (productStore as TourItineraryItem).product;
		}
	}
	return {
		dates: contract ? contract.dateBands : undefined,
		category: product ? product.category : undefined,
	};
};

const connected = connect(mapStateToProps, {})(ContractSimulatorView);
export { connected as ContractSimulatorView };



// WEBPACK FOOTER //
// ./src/app/products/contractSimulator/contract-simulator.view.tsx